/* eslint-disable consistent-return, default-case, no-param-reassign, no-shadow */
/*
 *
 * Security reducer
 *
 */

import produce from 'immer';

import { RESET_USER_STATE } from '../../Main/constants';
import {
  CHANGE_INPUT,
  CHANGE_STEP,
  CHECK_BIOMETRICS_AND_PIN_INFO,
  DISABLE_ALT_AUTH_METHODS,
  DISABLE_BIOMETRIC_LOGIN,
  DISABLE_BIOMETRIC_LOGIN_FAILURE,
  DISABLE_BIOMETRIC_LOGIN_SUCCESS,
  DISABLE_PIN,
  DISABLE_PIN_FAILURE,
  DISABLE_PIN_SUCCESS,
  ENABLE_BIOMETRIC_LOGIN,
  ENABLE_BIOMETRIC_LOGIN_FAILURE,
  ENABLE_BIOMETRIC_LOGIN_SUCCESS,
  FOCUS_INPUT,
  RESET_DRAWER_INPUTS_AND_ERRORS,
  RESET_STATE,
  SET_PIN,
  SET_PIN_FAILURE,
  SET_PIN_SUCCESS,
  UPDATE_BIOMETRICS_AND_PIN_INFO,
  UPDATE_ERROR,
} from './constants';

export const initialState = {
  errors: {
    bannerError: {
      pinDrawer: false,
      signInMethods: false,
    },
  },
  focus: { passcode: 0 },
  form: {
    confirmPin: '',
    pin: '',
  },
  isBiometricLoginEnabled: false,
  isPinEnabled: false,
  loading: true,
  step: 1,
  supportedBiometricAuthenticationTypes: [], // array of integers from 1-3
};

const securityReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case CHANGE_INPUT: {
      const { field, value } = payload;
      draft.form[field] = value;
      draft.errors.bannerError = initialState.errors.bannerError;
      break;
    }
    case CHANGE_STEP: {
      const { step } = payload;
      draft.step = step;
      break;
    }
    case CHECK_BIOMETRICS_AND_PIN_INFO: {
      draft.loading = true;
      break;
    }
    case DISABLE_ALT_AUTH_METHODS: {
      draft.isBiometricLoginEnabled = false;
      draft.isPinEnabled = false;
      break;
    }
    case DISABLE_BIOMETRIC_LOGIN: {
      draft.errors.bannerError.signInMethods = false;
      break;
    }
    case DISABLE_BIOMETRIC_LOGIN_FAILURE: {
      const { error } = payload;
      draft.errors.bannerError.signInMethods = error;
      break;
    }
    case DISABLE_BIOMETRIC_LOGIN_SUCCESS: {
      draft.isBiometricLoginEnabled = false;
      break;
    }
    case DISABLE_PIN: {
      draft.errors.bannerError.signInMethods = false;
      break;
    }
    case DISABLE_PIN_FAILURE: {
      const { error } = payload;
      draft.errors.bannerError.signInMethods = error;
      break;
    }
    case DISABLE_PIN_SUCCESS: {
      draft.isPinEnabled = false;
      break;
    }
    case ENABLE_BIOMETRIC_LOGIN: {
      draft.errors.bannerError.signInMethods = false;
      break;
    }
    case ENABLE_BIOMETRIC_LOGIN_FAILURE: {
      const { error } = payload;
      draft.errors.bannerError.signInMethods = error;
      break;
    }
    case ENABLE_BIOMETRIC_LOGIN_SUCCESS: {
      draft.isBiometricLoginEnabled = true;
      break;
    }
    case FOCUS_INPUT: {
      const { field } = payload;
      draft.focus[field] = Number(!draft.focus[field]);
      break;
    }
    case RESET_DRAWER_INPUTS_AND_ERRORS: {
      draft.errors.bannerError.pinDrawer = false;
      draft.form = initialState.form;
      break;
    }
    case RESET_STATE: {
      draft.errors = initialState.errors;
      draft.form = initialState.form;
      draft.step = initialState.step;
      break;
    }
    case RESET_USER_STATE: {
      draft.errors = initialState.errors;
      draft.form = initialState.form;
      draft.step = initialState.step;
      break;
    }
    case SET_PIN: {
      draft.errors.bannerError.pinDrawer = false;
      draft.errors.bannerError.signInMethods = false;
      break;
    }
    case SET_PIN_FAILURE: {
      const { error } = payload;
      draft.errors.bannerError.signInMethods = error;
      break;
    }
    case SET_PIN_SUCCESS: {
      draft.isPinEnabled = true;
      break;
    }
    case UPDATE_BIOMETRICS_AND_PIN_INFO: {
      const {
        isBiometricLoginEnabled,
        isPinEnabled,
        supportedBiometricAuthenticationTypes,
      } = payload;
      draft.isBiometricLoginEnabled = isBiometricLoginEnabled;
      draft.isPinEnabled = isPinEnabled;
      draft.loading = false;
      draft.supportedBiometricAuthenticationTypes = supportedBiometricAuthenticationTypes;
      break;
    }
    case UPDATE_ERROR: {
      const { subType, type, value } = payload;
      draft.errors[type][subType] = value;
      break;
    }
  }
}, initialState);

export default securityReducer;
